<mat-card-actions class="d-inline-flex justify-content-start align-items-baseline flex-wrap m-0 pl-3 p-sm-2"
    [ngClass]="{'d-flex w-100':hasExternalFiltersFirstLine || hasExternalFiltersSecondLine}">
    <!-- A la izquierda: en varios listados "Operaciones" flota a la derecha de esta fila.
         Sin ocultar por breakpoint: su primera emisión libera la búsqueda inicial. -->
    <div class="transport-company-context-slot mb-2 mb-sm-3" *ngIf="usesTransportCompanyContext">
        <app-transport-company-context [initialNit]="initialTransportCompanyId" size="field"
            (companyChange)="onTransportCompanyChange($event)">
        </app-transport-company-context>
    </div>
    <div class="d-none d-xl-inline-flex" *ngIf="hasExternalFiltersFirstLine"
        [ngClass]="{'d-xl-flex w-100':hasExternalFiltersSecondLine}">
        <!--Filtros que puedan ir en la primera linea-->
        <div class="button-t-group" *ngIf="filtersByOptions.showFilterAprovedCargo">
            <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('approval', 'all')"
                [ngClass]="{'selected': !['Pending approval', 'Approved', 'Rejected'].includes(staticFilters['approval'])}">
                Todos
            </div>
            <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('approval','Pending approval')"
                *ngIf="staticFilters['paid']!==true"
                [ngClass]="{'selected': staticFilters['approval']==='Pending approval'}">En revisión
            </div>
            <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('approval','Approved')"
                [ngClass]="{'selected': staticFilters['approval']==='Approved'}">Aprobados</div>
            <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('approval','Rejected')"
                *ngIf="staticFilters['paid']!==true" [ngClass]="{'selected': staticFilters['approval']==='Rejected'}">
                Rechazados</div>
        </div>
        <div class="button-t-group" *ngIf="filtersByOptions.showFilterPrevalidation">
            <div class="button-t flex-fill"
                (click)="setStaticFilterAndSearch('prevalidationValid','Pending validation')"
                [ngClass]="{'selected': staticFilters['prevalidationValid']=='Pending validation'}">Pendientes de
                validar
            </div>
            <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('prevalidationValid','Validated')"
                [ngClass]="{'selected': staticFilters['prevalidationValid']=='Validated'}">Validados</div>
        </div>
        <div class="button-t-group"
            *ngIf="filtersByOptions.showFilterMinistryFulfillment || filtersByOptions.showFilterCharges">
            <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('ministryFulfillment', 'all')"
                [ngClass]="{'selected': staticFilters['ministryFulfillment']!='true' && staticFilters['ministryFulfillment']!='false'}">
                Todos
            </div>
            <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('ministryFulfillment', 'false')"
                [ngClass]="{'selected': staticFilters['ministryFulfillment']=='false'}"
                *ngIf="hasTransportServicesCompany">
                Sin cumplir
            </div>
            <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('ministryFulfillment', 'true')"
                [ngClass]="{'selected': staticFilters['ministryFulfillment']=='true'}"
                *ngIf="hasTransportServicesCompany">
                Cumplidos
            </div>
        </div>
        <!-- <div class="button-t-group" *ngIf="options.showFilterAssignmentsCargo">
            <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('approval','Pending approval')"
                *ngIf="staticFilters['paid']!==true"
                [ngClass]="{'selected': staticFilters['approval']==='Pending approval'}">Sin asignar
            </div>
            <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('approval','Approved')"
                [ngClass]="{'selected': staticFilters['approval']==='Approved'}">Asignadas
            </div>
        </div> -->
        <div class="button-t-group" *ngIf="filtersByOptions.showFilterDriver">
            <div class="button-t flex-fill" (click)="setFilterDriver(true)"
                [ngClass]="{'selected': staticFilters['state']===cargoStateEnum.ACCEPTED}">
                {{hasSatelliteLockServicesCompany ? 'Asignados' : 'Con conductor asignado'}}
            </div>
            <div class="button-t flex-fill" (click)="setFilterDriver(false)"
                [ngClass]="{'selected': staticFilters['state']===cargoStateEnum.CREATED}">
                {{hasSatelliteLockServicesCompany ? 'Sin asignar' : 'Sin conductor asignado'}}
            </div>
        </div>
        <div class="button-t-group" *ngIf="filtersByOptions.showFilterRaiting">
            <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('qualified','')"
                [ngClass]="{'selected': staticFilters['qualified']===''}">Todos
            </div>
            <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('qualified',true)"
                [ngClass]="{'selected': staticFilters['qualified']===true}">Calificados
            </div>
            <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('qualified',false)"
                [ngClass]="{'selected': staticFilters['qualified']===false}">
                Sin calificación
            </div>
        </div>
        <div class="button-t-group" *ngIf="filtersByOptions.showFilterTransportRequests">
            <div class="button-t flex-fill" (click)="setFilterAssignedDriver(true)"
                [ngClass]="{'selected': staticFilters['states']?.includes(cargoStateEnum.ACCEPTED)}">
                Asignadas
            </div>
            <div class="button-t flex-fill" (click)="setFilterAssignedDriver(false)"
                [ngClass]="{'selected': !staticFilters['states']?.includes(cargoStateEnum.ACCEPTED)}">
                Sin asignar
            </div>
        </div>
        <div class="button-t-group" *ngIf="filtersByOptions.showFilterTypeUser">
            <div class="button-t flex-fill" (click)="setUserType('user')"
                [ngClass]="{'selected': staticFilters['type']==='user'}">Conductores
            </div>
            <div class="button-t flex-fill" (click)="setUserType('userClient')"
                [ngClass]="{'selected': staticFilters['type']==='userClient'}">Usuarios web
            </div>
        </div>
        <div *ngIf="filtersByOptions.showFilterTravelExpensesState" class="mt-3 d-flex align-items-baseline">
            <span>Estado:</span>
            <mat-form-field appearance="outline" class="external-form-field">
                <mat-select [(ngModel)]="staticFilters['travelExpenseGlobalStatus']" (selectionChange)="search()">
                    <mat-option *ngFor="let travelExpenseState of travelExpensesCheckingStates"
                        [value]="travelExpenseState.id">
                        {{getTravelExpensesStateName(travelExpenseState.id)}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div *ngIf="filtersByOptions.showFilterTravelExpensesState" class="mt-3 ml-2 d-flex align-items-baseline">
            <span>Saldo:</span>
            <mat-form-field appearance="outline" class="external-form-field">
                <mat-select [(ngModel)]="staticFilters['approveBalance']" (selectionChange)="search()">
                    <mat-option [value]="true">
                        Pago aprobado
                    </mat-option>
                    <mat-option [value]="false">
                        Pago sin aprobar
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

    </div>
    <hr *ngIf="hasExternalFiltersFirstLine && hasExternalFiltersSecondLine" class="w-100 m-0 d-none d-xl-block">
    <div class="d-none d-xl-inline-flex" *ngIf="hasExternalFiltersSecondLine">
        <!--Filtros que puedan ir en una segunda linea-->
        <div *ngIf="filtersByOptions.showFilterPaymentBalanceCargo" class="mt-3 d-flex align-items-baseline">
            <span>Tipo:</span>
            <mat-form-field appearance="outline" class="external-form-field">
                <mat-select [(ngModel)]="filterPayment" (selectionChange)="setFilterPayment($event.value)">
                    <mat-option value="fastPay" *ngIf="hasFastPaymentEnabled">
                        Pronto pago
                    </mat-option>
                    <mat-option value="pendingToPay">
                        Por pagar
                    </mat-option>
                    <mat-option value="paid">
                        Pagados
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="mt-3 ml-2 d-flex align-items-baseline"
            *ngIf="filtersByOptions.showFilterApprovalState && staticFilters['fastPayment'] === true">
            <span>Aprobación:</span>
            <mat-form-field appearance="outline" class="external-form-field">
                <mat-select [formControl]="form.get('approval')" (selectionChange)="search()">
                    <mat-option value="">Todos</mat-option>
                    <mat-option value="Rejected">Rechazados</mat-option>
                    <mat-option value="Approved">Aprobados</mat-option>
                    <mat-option value="Pending approval">Pendientes de aprobación</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div *ngIf="filtersByOptions.showFilterPaymentAdvanceCargo" class="mt-3 d-flex align-items-baseline">
            <span>Estado:</span>
            <mat-form-field appearance="outline" class="external-form-field">
                <mat-select [(ngModel)]="staticFilters['requestedAdvance']"
                    (selectionChange)="setAdvanceState($event.value)">
                    <mat-option [value]="true">
                        Solicitados
                    </mat-option>
                    <mat-option [value]="false">
                        No solicitados
                    </mat-option>
                    <mat-option [value]="''">
                        Pagados
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div *ngIf="filtersByOptions.showFilterPrevalidation" class="mt-3 d-flex align-items-baseline">
            <app-autocomplete-user-client [inputFormControl]="userClientControl"
                [options]="optionsUserClient"></app-autocomplete-user-client>
        </div>
        <div *ngIf="filtersByOptions.showFilterWithoutPayment" class="mt-3 d-flex align-items-baseline">
            <span>Estado:</span>
            <mat-form-field appearance="outline" class="external-form-field">
                <mat-select [(ngModel)]="staticFilters['journalError']" (selectionChange)="search()">
                    <mat-option [value]="true">
                        Con error
                    </mat-option>
                    <mat-option [value]="''">
                        Todas
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div *ngIf="filtersByOptions.showFilterPaymentAdditionalCostsCargo" class="mt-3 d-flex align-items-baseline">
            <span>Tipo:</span>
            <mat-form-field appearance="outline" class="external-form-field">
                <mat-select [(ngModel)]="staticFilters['additionalCost']"
                    (selectionChange)="setAdditionalCostPaid($event.value)">
                    <mat-option value="Servicio cargue">
                        Cargues por pagar
                    </mat-option>
                    <mat-option value="Servicio descargue">
                        Descargues por pagar
                    </mat-option>
                    <mat-option value="Stand by">
                        Stand by por pagar
                    </mat-option>
                    <mat-option [value]="''">
                        Servicios pagados
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div *ngIf="filtersByOptions.showFilterPaymentExpenses && travelExpenseTypes?.length"
            class="mt-3 d-flex align-items-baseline">
            <span>Concepto:</span>
            <mat-form-field appearance="outline" class="external-form-field">
                <mat-select [(ngModel)]="staticFilters['travelExpensesType']" (selectionChange)="search()">
                    <mat-option *ngFor="let travelExpenseType of travelExpenseTypes" [value]="travelExpenseType.name">
                        {{travelExpenseType.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="secondary-button-t-group ml-1" *ngIf="filtersByOptions.showFilterPaymentState">
            <div class="button-t" (click)="setStaticFilterAndSearch('paid', null)"
                [ngClass]="{'selected': staticFilters['paid']!==true && staticFilters['paid']!==false}">
                Todos
            </div>
            <div class="button-t" (click)="setStaticFilterAndSearch('paid', false)"
                [ngClass]="{'selected': staticFilters['paid'] === false}">
                Por pagar
            </div>
            <div class="button-t" (click)="setStaticFilterAndSearch('paid', true)"
                [ngClass]="{'selected': staticFilters['paid'] === true}"
                *ngIf="!['Pending approval', 'Rejected'].includes(staticFilters['approval'])">
                Pagados
            </div>
        </div>
        <div *ngIf="filtersByOptions.showFilterPaymentExpensesPaymentType && travelExpenseStates?.length"
            class="mt-3 ml-2 d-flex align-items-baseline">
            <span>Estado:</span>
            <mat-form-field appearance="outline" class="external-form-field">
                <mat-select [(ngModel)]="staticFilters['paid']" (selectionChange)="search()">
                    <mat-option *ngFor="let travelExpenseState of travelExpenseStates"
                        [value]="travelExpenseState.value">
                        {{travelExpenseState.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div *ngIf="filtersByOptions.showFilterCharges" class="mt-3 d-flex align-items-baseline" style="width: 400px;">
            <span>Estado:</span>
            <mat-form-field appearance="outline" class="external-form-field">
                <mat-select [(ngModel)]="filterCharges" (selectionChange)="setFilterCharges($event.value)">
                    <mat-option value="1">
                        Sin factura asignada
                    </mat-option>
                    <mat-option value="2">
                        Facturada - Sin Comprobante
                    </mat-option>
                    <mat-option value="3">
                        Comprobadas
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div *ngIf="filtersByOptions.showFilterPublicationZone && hasTransportServicesCompany"
            class="mt-3 d-flex align-items-baseline">
            <span>Zona:</span>
            <mat-form-field appearance="outline" class="external-form-field">
                <mat-select [formControl]="form.get('zone')" (selectionChange)="search()">
                    <mat-option value="private">
                        Privada
                    </mat-option>
                    <mat-option value="public">
                        Pública
                    </mat-option>
                    <mat-option value="reserved">
                        Reservada
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <button mat-raised-button class="btn-filter mb-2 mb-sm-3" title="Filtrar" (click)="openLateralFilter()"
        [ngClass]="{'d-inline-block d-xl-none':hasExternalFiltersFirstLine||hasExternalFiltersSecondLine}">
        <i *ngIf="numberOfAppliedFilters" class="fas fa-filter ml-2" [matBadge]="numberOfAppliedFilters"
            matBadgeColor="warn"></i>
        <i *ngIf="!numberOfAppliedFilters" class="fas fa-filter"></i>
        <span class="ml-2">Filtrar</span>
    </button>
    <button mat-raised-button class="btn-filter--external-filters mb-3 ml-xl-3 d-none d-xl-inline-block"
        title="Más filtros" (click)="openLateralFilter()"
        *ngIf="hasExternalFiltersFirstLine||hasExternalFiltersSecondLine">
        <i *ngIf="numberOfAppliedFilters" class="fas fa-filter ml-2" [matBadge]="numberOfAppliedFilters"
            matBadgeColor="warn"></i>
        <i *ngIf="!numberOfAppliedFilters" class="fas fa-filter"></i>
        <span class="ml-2">Más filtros</span>
    </button>
</mat-card-actions>
<div class="container-filters" *ngIf="showLateralFilter">
    <div class="background-exit" (click)="closeLateralFilter()"></div>
    <div class="filters" id="filters">
        <div class="filter-list">
            <div class="title-1">
                <i class="fas fa-filter" title="Mas filtros"></i>
                Filtros
            </div>
            <div class="scrollable-list">
                <div class="my-3 d-xl-none d-block">
                    <div class="button-t-group ml-1" *ngIf="filtersByOptions.showFilterAprovedCargo">
                        <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('approval', 'all')"
                            [ngClass]="{'selected': !['Pending approval', 'Approved', 'Rejected'].includes(staticFilters['approval'])}">
                            Todos
                        </div>
                        <div class="button-t flex-fill"
                            (click)="setStaticFilterAndSearch('approval','Pending approval')"
                            *ngIf="staticFilters['paid']!==true"
                            [ngClass]="{'selected': staticFilters['approval']==='Pending approval'}">En revisión
                        </div>
                        <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('approval','Approved')"
                            [ngClass]="{'selected': staticFilters['approval']==='Approved'}">Aprobados</div>
                        <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('approval','Rejected')"
                            *ngIf="staticFilters['paid']!==true"
                            [ngClass]="{'selected': staticFilters['approval']==='Rejected'}">Rechazados</div>
                    </div>
                    <div class="button-t-group ml-1" *ngIf="filtersByOptions.showFilterPrevalidation">
                        <div class="button-t flex-fill"
                            (click)="setStaticFilterAndSearch('prevalidationValid','Pending validation')"
                            [ngClass]="{'selected': staticFilters['prevalidationValid']=='Pending validation'}">
                            Pendientes de validar
                        </div>
                        <div class="button-t flex-fill"
                            (click)="setStaticFilterAndSearch('prevalidationValid','Validated')"
                            [ngClass]="{'selected': staticFilters['prevalidationValid']=='Validated'}">Validados</div>
                    </div>
                    <div class="button-t-group ml-1"
                        *ngIf="filtersByOptions.showFilterMinistryFulfillment || filtersByOptions.showFilterCharges">
                        <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('ministryFulfillment', 'all')"
                            [ngClass]="{'selected': staticFilters['ministryFulfillment']!='true' && staticFilters['ministryFulfillment']!='false'}">
                            Todos
                        </div>
                        <div class="button-t flex-fill"
                            (click)="setStaticFilterAndSearch('ministryFulfillment', 'false')"
                            [ngClass]="{'selected': staticFilters['ministryFulfillment']=='false'}"
                            *ngIf="hasTransportServicesCompany">
                            Sin cumplir
                        </div>
                        <div class="button-t flex-fill"
                            (click)="setStaticFilterAndSearch('ministryFulfillment', 'true')"
                            [ngClass]="{'selected': staticFilters['ministryFulfillment']=='true'}"
                            *ngIf="hasTransportServicesCompany">
                            Cumplidos
                        </div>
                    </div>
                    <div class="secondary-button-t-group ml-1" *ngIf="filtersByOptions.showFilterPaymentBalanceCargo">
                        <div *ngIf="hasFastPaymentEnabled" class="button-t flex-fill"
                            (click)="setFilterPayment('fastPay')" [ngClass]="{'selected': filterPayment==='fastPay'}">
                            Pronto pago
                        </div>
                        <div class="button-t flex-fill" (click)="setFilterPayment('pendingToPay')"
                            [ngClass]="{'selected': filterPayment==='pendingToPay'}">Por pagar</div>
                        <div class="button-t flex-fill" (click)="setFilterPayment('paid')"
                            [ngClass]="{'selected': filterPayment==='paid'}">Pagados</div>
                    </div>
                    <div class="secondary-button-t-group ml-1" *ngIf="filtersByOptions.showFilterPaymentAdvanceCargo">
                        <div class="button-t flex-fill" (click)="setAdvanceState(true)"
                            [ngClass]="{'selected': staticFilters['requestedAdvance']===true}">Solicitados
                        </div>
                        <div class="button-t flex-fill" (click)="setAdvanceState(false)"
                            [ngClass]="{'selected': staticFilters['requestedAdvance']===false}">No solicitados</div>
                        <div class="button-t flex-fill" (click)="setAdvanceState('')"
                            [ngClass]="{'selected': staticFilters['requestedAdvance']===''}">Pagados</div>
                    </div>
                    <div class="secondary-button-t-group ml-1" *ngIf="filtersByOptions.showFilterWithoutPayment">
                        <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('journalError',true)"
                            [ngClass]="{'selected': staticFilters['journalError']===true}">Con error
                        </div>
                        <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('journalError','')"
                            [ngClass]="{'selected': staticFilters['journalError']===''}">Todas</div>
                    </div>

                    <div class="secondary-button-t-group  ml-1"
                        *ngIf="filtersByOptions.showFilterPaymentAdditionalCostsCargo">
                        <div class="button-t flex-fill" (click)="setAdditionalCostPaid('Servicio cargue')"
                            [ngClass]="{'selected': staticFilters['additionalCost']==='Servicio cargue'}">Cargues por
                            pagar
                        </div>
                        <div class="button-t flex-fill" (click)="setAdditionalCostPaid('Servicio descargue')"
                            [ngClass]="{'selected': staticFilters['additionalCost']==='Servicio descargue'}">Descargues
                            por
                            pagar</div>
                        <div class="button-t flex-fill" (click)="setAdditionalCostPaid('Stand by')"
                            [ngClass]="{'selected': staticFilters['additionalCost']==='Stand by'}">Stand By por pagar
                        </div>
                        <div class="button-t flex-fill" (click)="setAdditionalCostPaid('')"
                            [ngClass]="{'selected': staticFilters['additionalCost']===''}">Servicios pagados</div>
                    </div>
                    <div class="button-t-group ml-1" *ngIf="filtersByOptions.showFilterDriver">
                        <div class="button-t flex-fill" (click)="setFilterDriver(true)"
                            [ngClass]="{'selected': staticFilters['state']===cargoStateEnum.ACCEPTED}">
                            {{hasSatelliteLockServicesCompany ? 'Asignados' : 'Con conductor asignado'}}
                        </div>
                        <div class="button-t flex-fill" (click)="setFilterDriver(false)"
                            [ngClass]="{'selected': staticFilters['state']===cargoStateEnum.CREATED}">
                            {{hasSatelliteLockServicesCompany ? 'Sin asignar' : 'Sin conductor asignado'}}
                        </div>
                    </div>
                    <div class="secondary-button-t-group ml-1" *ngIf="filtersByOptions.showFilterCharges">
                        <div class="button-t flex-fill" (click)="setFilterCharges('1')"
                            [ngClass]="{'selected': staticFilters['cashed']===false}">Sin factura asignada
                        </div>
                        <div class="button-t flex-fill" (click)="setFilterCharges('2')"
                            [ngClass]="{'selected': staticFilters['cashed']===true && staticFilters['checked']===false}">
                            Facturada - Sin Comprobante
                        </div>
                        <div class="button-t flex-fill" (click)="setFilterCharges('3')"
                            [ngClass]="{'selected': staticFilters['cashed']===true && staticFilters['checked']===true}">
                            Comprobadas
                        </div>
                    </div>
                    <div class="button-t-group ml-1" *ngIf="filtersByOptions.showFilterRaiting">
                        <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('qualified','')"
                            [ngClass]="{'selected': staticFilters['qualified']===''}">Todos
                        </div>
                        <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('qualified',true)"
                            [ngClass]="{'selected': staticFilters['qualified']===true}">Calificados
                        </div>
                        <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('qualified',false)"
                            [ngClass]="{'selected': staticFilters['qualified']===false}">
                            Sin calificación
                        </div>
                    </div>
                    <div class="button-t-group ml-1" *ngIf="filtersByOptions.showFilterTransportRequests">
                        <div class="button-t flex-fill" (click)="setFilterAssignedDriver(true)"
                            [ngClass]="{'selected': staticFilters['states']?.includes(cargoStateEnum.ACCEPTED)}">
                            Asignadas
                        </div>
                        <div class="button-t flex-fill" (click)="setFilterAssignedDriver(false)"
                            [ngClass]="{'selected': !staticFilters['states']?.includes(cargoStateEnum.ACCEPTED)}">
                            Sin asignar
                        </div>
                    </div>
                    <div class="secondary-button-t-group ml-1" *ngIf="filtersByOptions.showFilterPaymentState">
                        <div class="button-t" (click)="setStaticFilterAndSearch('paid', null)"
                            [ngClass]="{'selected': staticFilters['paid']!==true && staticFilters['paid']!==false}">
                            Todos
                        </div>
                        <div class="button-t" (click)="setStaticFilterAndSearch('paid', false)"
                            [ngClass]="{'selected': staticFilters['paid']===false}">Por pagar
                        </div>
                        <div class="button-t" (click)="setStaticFilterAndSearch('paid',true)"
                            *ngIf="!['Pending approval', 'Rejected'].includes(staticFilters['approval'])"
                            [ngClass]="{'selected': staticFilters['paid']===true}">Pagados
                        </div>
                    </div>

                    <div class="button-t-group ml-1" *ngIf="filtersByOptions.showFilterTypeUser">
                        <div class="button-t flex-fill" (click)="setUserType('user')"
                            [ngClass]="{'selected': staticFilters['type']==='user'}">Conductores
                        </div>
                        <div class="button-t flex-fill" (click)="setUserType('userClient')"
                            [ngClass]="{'selected': staticFilters['type']==='userClient'}">Usuarios web
                        </div>
                    </div>
                    <div *ngIf="filtersByOptions.showFilterPaymentExpenses">
                        <p class="mt-3 text-bold">Concepto: </p>
                        <div class="secondary-button-t-group ml-1">
                            <div class="button-t"
                                (click)="setStaticFilterAndSearch('travelExpensesType', travelExpenseType.name)"
                                *ngFor="let travelExpenseType of travelExpenseTypes"
                                [ngClass]="{'selected': staticFilters['travelExpensesType'] === travelExpenseType.name}">
                                {{travelExpenseType.name}}
                            </div>
                        </div>
                    </div>
                    <div *ngIf="filtersByOptions.showFilterPaymentExpensesPaymentType">
                        <p class="mt-3 text-bold">Estado: </p>
                        <div class="secondary-button-t-group ml-1">
                            <div class="button-t" (click)="setStaticFilterAndSearch('paid', travelExpenseState.value)"
                                *ngFor="let travelExpenseState of travelExpenseStates"
                                [ngClass]="{'selected': staticFilters['paid'] === travelExpenseState.value}">
                                {{travelExpenseState.name}}
                            </div>
                        </div>
                    </div>

                    <mat-form-field *ngIf="filtersByOptions.showFilterTravelExpensesState" appearance="outline">
                        <mat-label>Estado</mat-label>
                        <mat-select [(ngModel)]="staticFilters['travelExpenseGlobalStatus']"
                            (selectionChange)="search()">
                            <mat-option *ngFor="let travelExpenseState of travelExpensesCheckingStates"
                                [value]="travelExpenseState.id">
                                {{getTravelExpensesStateName(travelExpenseState.id)}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field *ngIf="filtersByOptions.showFilterTravelExpensesState" appearance="outline">
                        <mat-label>Saldo</mat-label>
                        <mat-select [(ngModel)]="staticFilters['approveBalance']" (selectionChange)="search()">
                            <mat-option [value]="true">Pago aprobado</mat-option>
                            <mat-option [value]="false">Pago sin aprobar</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <!-- Ordenamiento -->
                <div *ngIf="filtersByOptions.showFilterOrderByTracking" class="my-3">
                    <div class="title-2 mt-3 w-100">
                        <span class="text-bold">Ordenar por: </span>Seguimiento
                    </div>
                    <div class="secondary-button-t-group ml-1">
                        <div class="button-t flex-fill" (click)="setStaticFilterAndSearch('orderBy', 'oldFirst', true)"
                            [ngClass]="{'selected': staticFilters['orderBy']==='oldFirst'}">Del más antiguo al más
                            reciente
                        </div>
                        <div class="button-t flex-fill"
                            (click)="setStaticFilterAndSearch('orderBy', 'recentFirst', true)"
                            [ngClass]="{'selected': staticFilters['orderBy']==='recentFirst'}">Del más reciente al más
                            antiguo</div>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center flex-wrap mt-2"
                    *ngIf="numberOfAppliedFilters>0">
                    <div class="title-2 text-bold">Filtros aplicados:</div>
                    <div (click)="cleanAllFilters()" class="underline color-secondary-dark">Limpiar filtros</div>
                </div>
                <div class="pl-2" *ngIf="numberOfAppliedFilters>0">
                    <mat-chip-list>
                        <div *ngIf="appliedFilters?.nits?.length">
                            <mat-chip class="chip" *ngFor="let company of appliedFilters.nits; let i = index">
                                {{company | companyName}}
                                <mat-icon matChipRemove (click)="cleanFilter('nits',i)">cancel</mat-icon>
                            </mat-chip>
                        </div>
                        <mat-chip class="chip" *ngIf="appliedFilters?.errorManifest">
                            Con errores en el manifiesto
                            <mat-icon matChipRemove (click)="cleanFilter('errorManifest')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.nit">
                            Compañía: {{appliedFilters.nit | companyName}}
                            <mat-icon matChipRemove (click)="cleanFilter('nit')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.transportCompanyId">
                            Empresa de transporte: {{appliedFilters.transportCompanyId | companyName}}
                            <mat-icon matChipRemove (click)="cleanFilter('transportCompanyId')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.licensePlate">
                            Placa: {{appliedFilters.licensePlate}}
                            <mat-icon matChipRemove (click)="cleanFilter('licensePlate')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.trailerId && filterBy === 'cargo'">
                            Trailer: {{appliedFilters.trailerId}}
                            <mat-icon matChipRemove (click)="cleanFilter('trailerId')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.escortedLicensePlate">
                            Placa escoltada: {{appliedFilters.escortedLicensePlate}}
                            <mat-icon matChipRemove (click)="cleanFilter('escortedLicensePlate')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.imeiLock">
                            IMEI del candado: {{appliedFilters.imeiLock}}
                            <mat-icon matChipRemove (click)="cleanFilter('imeiLock')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.userClientDocument">
                            Creador: {{appliedFilters.userClientDocument}}
                            <mat-icon matChipRemove (click)="cleanFilter('userClientDocument')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.lockId">
                            ID del candado: {{appliedFilters.lockId}}
                            <mat-icon matChipRemove (click)="cleanFilter('lockId')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.typeNameLock">
                            Tipo de candado: {{appliedFilters.typeNameLock}}
                            <mat-icon matChipRemove (click)="cleanFilter('typeNameLock')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.dateLoad">
                            Desde: {{appliedFilters.dateLoad | dateFormat:'only-date'}}
                            <mat-icon matChipRemove (click)="cleanFilter('dateLoad')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.endDate">
                            Hasta: {{appliedFilters.endDate | dateFormat:'only-date'}}
                            <mat-icon matChipRemove (click)="cleanFilter('endDate')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.creationDateInitial">
                            Desde: {{appliedFilters.creationDateInitial | dateFormat:'only-date'}}
                            <mat-icon matChipRemove (click)="cleanFilter('creationDateInitial')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.creationDateFinal">
                            Hasta: {{appliedFilters.creationDateFinal | dateFormat:'only-date'}}
                            <mat-icon matChipRemove (click)="cleanFilter('creationDateFinal')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.lastPointExistance">
                            Servicios {{appliedFilters.lastPointExistance==="true"? 'con': 'sin'}} seguimiento
                            registrado
                            <mat-icon matChipRemove (click)="cleanFilter('lastPointExistance')">cancel</mat-icon>
                        </mat-chip>
                        <div *ngIf="appliedFilters?.labels?.length">
                            <mat-chip class="chip" *ngFor="let tag of appliedFilters?.labels; let i = index">
                                Etiqueta: {{tag}}
                                <mat-icon matChipRemove (click)="clearTag(tag)">cancel</mat-icon>
                            </mat-chip>
                        </div>
                        <mat-chip class="chip" *ngIf="appliedFilters?.lastPointLapse">
                            Último seguimiento hace {{appliedFilters.lastPointLapse}} horas
                            <mat-icon matChipRemove (click)="cleanFilter('lastPointLapse')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.containerExpirationLapse">
                            Caducidad del contenedor en {{appliedFilters.containerExpirationLapse}} días
                            <mat-icon matChipRemove (click)="cleanFilter('containerExpirationLapse')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.consecutive">
                            Nº ID servicio: {{appliedFilters.consecutive}}
                            <mat-icon matChipRemove (click)="cleanFilter('consecutive')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.consecutiveMainCargo">
                            Nº ID consolidado base: {{appliedFilters.consecutiveMainCargo}}
                            <mat-icon matChipRemove (click)="cleanFilter('consecutiveMainCargo')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.container">
                            Contenedor: {{appliedFilters.container}}
                            <mat-icon matChipRemove (click)="cleanFilter('container')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.tripCategory">
                            Categoría: {{appliedFilters.tripCategory}}
                            <mat-icon matChipRemove (click)="cleanFilter('tripCategory')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.zone">
                            Publicación: {{appliedFilters.zone === 'private'? 'Privada' : appliedFilters.zone ===
                            'public' ? 'Pública' : 'Reservada'}}
                            <mat-icon matChipRemove (click)="cleanFilter('zone')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.prevalidationValid">
                            Validación: {{appliedFilters.prevalidationValid == 'true' ? 'Validado' : 'Pendiente de
                            validación'}}
                            <mat-icon matChipRemove (click)="cleanFilter('prevalidationValid')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="utils.isDefined(appliedFilters?.requiresPreBill)">
                            Requiere pre-factura: {{appliedFilters.requiresPreBill == 'true' ? 'Si' : 'No'}}
                            <mat-icon matChipRemove (click)="cleanFilter('requiresPreBill')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.preBill">
                            Pre-factura: {{appliedFilters.preBill}}
                            <mat-icon matChipRemove (click)="cleanFilter('preBill')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.numberDocumentSender">
                            Código de identificador cliente: {{appliedFilters.numberDocumentSender}}
                            <mat-icon matChipRemove (click)="cleanFilter('numberDocumentSender')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.driver && filterBy === 'cargo'">
                            Nº doc conductor: {{appliedFilters.driver}}
                            <mat-icon matChipRemove (click)="cleanFilter('driver')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.manifest">
                            Nº Manifiesto: {{appliedFilters.manifest}}
                            <mat-icon matChipRemove (click)="cleanFilter('manifest')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.billId">
                            Nº ID Factura: {{appliedFilters.billId}}
                            <mat-icon matChipRemove (click)="cleanFilter('billId')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.tripTypeName">
                            Tipo de carga: {{appliedFilters.tripTypeName}}
                            <mat-icon matChipRemove (click)="cleanFilter('tripTypeName')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.regimenType">
                            Tipo de régimen: {{appliedFilters.regimenType}}
                            <mat-icon matChipRemove (click)="cleanFilter('regimenType')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.riskProfileId">
                            Perfil de riesgo: {{getRiskProfileName(appliedFilters.riskProfileId)}}
                            <mat-icon matChipRemove (click)="cleanFilter('riskProfileId')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.fastPayment">
                            Servicios {{appliedFilters.fastPayment==="true"? "con" : "sin"}} pronto pago
                            <mat-icon matChipRemove (click)="cleanFilter('fastPayment')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.confirmedDriver">
                            Servicios {{appliedFilters.confirmedDriver==="true"? "con": "sin"}}
                            {{hasSatelliteLockServicesCompany ? 'confirmación' : 'conductor confirmado'}}
                            <mat-icon matChipRemove (click)="cleanFilter('confirmedDriver')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.startAmount||appliedFilters?.endAmount">
                            Valor:
                            {{appliedFilters.startAmount? (appliedFilters.startAmount| currency:'COP'): "0 COP"}}
                            {{appliedFilters.endAmount? ' - '+(appliedFilters.endAmount| currency:'COP'):
                            " en adelante"}}
                            <mat-icon matChipRemove (click)="cleanFilter('amount')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.news">
                            Reporte: {{appliedFilters.news}}
                            <mat-icon matChipRemove (click)="cleanFilter('news')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.origin">
                            Origen: {{appliedFilters.origin}}
                            <mat-icon matChipRemove (click)="cleanFilter('origin')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.destination">
                            Destino: {{appliedFilters.destination}}
                            <mat-icon matChipRemove (click)="cleanFilter('destination')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.state && filterBy !== 'vehicle'">
                            Estado: {{appliedFilters.state === '1'
                            ? "Con documentos pendientes por validar"
                            :appliedFilters.state === "true"?"Activo":"Inactivo"}}
                            <mat-icon matChipRemove (click)="cleanFilter('state')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.role">
                            Rol: {{appliedFilters.role | roleTranslate}}
                            <mat-icon matChipRemove (click)="cleanFilter('role')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.document">
                            Documento: {{appliedFilters.document}}
                            <mat-icon matChipRemove (click)="cleanFilter('document')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.phone">
                            Celular: {{appliedFilters.phone}}
                            <mat-icon matChipRemove (click)="cleanFilter('phone')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.email">
                            Correo: {{appliedFilters.email}}
                            <mat-icon matChipRemove (click)="cleanFilter('email')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.cargoConsecutive">
                            Consecutivo: {{appliedFilters.cargoConsecutive}}
                            <mat-icon matChipRemove (click)="cleanFilter('cargoConsecutive')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.approval">
                            Aprobación: {{appliedFilters.approval==='Approved'? 'Aprobados':
                            appliedFilters.approval === 'Rejected' ? 'Rechazados': 'Pendientes de aprobación'}}
                            <mat-icon matChipRemove (click)="cleanFilter('approval')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.paid">
                            Pagado: {{appliedFilters.paid ? 'Si' : 'No'}}
                            <mat-icon matChipRemove (click)="cleanFilter('paid')">cancel</mat-icon>
                        </mat-chip>
                        <!--Vehicles filters-->
                        <mat-chip class="chip" *ngIf="appliedFilters?.id && filterBy === 'vehicle'">
                            Placa: {{appliedFilters.id}}
                            <mat-icon matChipRemove (click)="cleanFilter('id')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.type && filterBy === 'vehicle'">
                            Tipo: {{appliedFilters.type}}
                            <mat-icon matChipRemove (click)="cleanFilter('type')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip"
                            *ngIf="(appliedFilters?.stateAccountAdvance || appliedFilters?.stateAccountBalance) && filterBy === 'vehicle'">
                            Estado de cuenta: {{getInitialFilterAccountState()}}
                            <mat-icon matChipRemove (click)="cleanFilter('accountState')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.state && filterBy === 'vehicle'">
                            Estado: {{appliedFilters.state==='true' ? 'Activo' : 'Inactivo'}}
                            <mat-icon matChipRemove (click)="cleanFilter('state')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.driver && filterBy === 'vehicle'">
                            Conductor: {{appliedFilters.driver}}
                            <mat-icon matChipRemove (click)="cleanFilter('driver')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.owner && filterBy === 'vehicle'">
                            Propietario: {{appliedFilters.owner}}
                            <mat-icon matChipRemove (click)="cleanFilter('owner')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.administrator && filterBy === 'vehicle'">
                            Administrador: {{appliedFilters.administrator}}
                            <mat-icon matChipRemove (click)="cleanFilter('administrator')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.companyId && filterBy === 'vehicle' && isRootNit">
                            Compañía: {{appliedFilters.companyId | companyName}}
                            <mat-icon matChipRemove (click)="cleanFilter('companyId')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.trailerId && filterBy === 'vehicle'">
                            Trailer: {{appliedFilters.trailerId}}
                            <mat-icon matChipRemove (click)="cleanFilter('trailerId')">cancel</mat-icon>
                        </mat-chip>
                        <!--Satellite Lock filters chips-->
                        <mat-chip class="chip" *ngIf="appliedFilters?.id && filterBy === 'satelliteLock'">
                            ID: {{appliedFilters.id}}
                            <mat-icon matChipRemove (click)="cleanFilter('id')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.typeName && filterBy === 'satelliteLock'">
                            Tipo: {{appliedFilters.typeName}}
                            <mat-icon matChipRemove (click)="cleanFilter('typeName')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.stateDevice && filterBy === 'satelliteLock'">
                            Estado del dispositivo: {{appliedFilters.stateDevice === SatelliteLockStateDevice.ACTIVE ?
                            'Activo' :
                            appliedFilters.stateDevice === SatelliteLockStateDevice.INACTIVE ? 'Inactivo' : 'En
                            mantenimiento'}}
                            <mat-icon matChipRemove (click)="cleanFilter('stateDevice')">cancel</mat-icon>
                        </mat-chip>
                        <mat-chip class="chip" *ngIf="appliedFilters?.imei && filterBy === 'satelliteLock'">
                            IMEI: {{appliedFilters.imei}}
                            <mat-icon matChipRemove (click)="cleanFilter('imei')">cancel</mat-icon>
                        </mat-chip>
                    </mat-chip-list>
                </div>

                <div class="row" [formGroup]="form" (keydown.enter)="onEnterApplyFilter($event)">
                    <div class="title-2 text-bold mt-3 col-12">
                        Filtrar por:
                    </div>
                    <!--General filters-->
                    <div class="col-12"
                        *ngIf="filtersByOptions.showFilterMultipleCompanies && isRootNit; else companyFilter">
                        <app-select-company [options]="optionsCompanies" [inputFormControl]="companiesControl">
                        </app-select-company>
                    </div>
                    <ng-template #companyFilter>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterCompany && isRootNit">
                            <app-select-company [options]="optionsCompanyfilter" [inputFormControl]="companySelected">
                            </app-select-company>
                        </div>
                    </ng-template>

                    <div class="col-12"
                        *ngIf="filtersByOptions.showFilterMultipleCompanies && isRootNit && form.get('nits')?.value?.length">
                        <mat-chip class="chip" *ngFor="let nit of form.get('nits')?.value">
                            {{nit| companyName}}
                            <mat-icon matChipRemove (click)="clearCompany(nit)">cancel</mat-icon>
                        </mat-chip>
                    </div>
                    <!--Cargo filters-->

                    <div *ngIf="filterBy==='cargo'" class="w-100 d-flex flex-wrap mt-3">
                        <app-select-transport-company class="col-12"
                            *ngIf="filtersByOptions.showFilterTransportCompany && hasTransportServicesCompany"
                            [inputFormControl]="form.get('transportCompanyId')" [options]="{
                                valueMode: 'id'
                            }">
                        </app-select-transport-company>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterIncident">
                            <mat-form-field>
                                <mat-label>Reporte de seguimiento</mat-label>
                                <mat-select formControlName="news">
                                    <mat-option *ngFor="let incident of incidents" [value]="incident.name">
                                        {{incident.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions.showFilterErrorManifest && hasTransportServicesCompany">
                            <mat-checkbox class="check" [formControl]="filterErrorManifest"
                                (change)="changeFilterErrorManifest($event)">
                                Error en manifiesto
                            </mat-checkbox>
                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions.showfilterlicensePlate && (hasTransportServicesCompany || hasEscortServicesCompany)">
                            <mat-form-field>
                                <mat-label>Placa del vehículo</mat-label>
                                <input appLicensePlate type="text" matInput formControlName="licensePlate">
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showfilterIdCargo">
                            <mat-form-field>
                                <mat-label>Nº ID servicio</mat-label>
                                <input type="text" matInput onlyNumbersInt formControlName="consecutive">
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterCargoConsecutive">
                            <mat-form-field>
                                <mat-label>Nº ID servicio</mat-label>
                                <input type="text" matInput onlyNumbersInt formControlName="cargoConsecutive">
                            </mat-form-field>
                        </div>
                        <div class="col-6 xs-12" *ngIf="filtersByOptions.showFilterDate">
                            <mat-form-field>
                                <mat-label>Desde</mat-label>
                                <input matInput [matDatepicker]="pickerLoadDate" readonly
                                    (dateChange)="setDate($event, 'load')" [formControl]="dateLoad"
                                    (click)="pickerLoadDate.open()">
                                <mat-datepicker-toggle matPrefix [for]="pickerLoadDate"></mat-datepicker-toggle>
                                <mat-datepicker #pickerLoadDate></mat-datepicker>
                                <mat-icon matSuffix class="x-icon" *ngIf="actualFilters.dateLoad"
                                    (click)="cleanFilter('dateLoad')">cancel</mat-icon>
                            </mat-form-field>
                        </div>
                        <div class="col-6 xs-12" *ngIf="filtersByOptions.showFilterDate">
                            <mat-form-field>
                                <mat-label>Hasta</mat-label>
                                <input matInput [matDatepicker]="pickerEndDate" readonly
                                    (dateChange)="setDate($event, 'end')" [formControl]="endDate"
                                    (click)="pickerEndDate.open()">
                                <mat-datepicker-toggle matPrefix [for]="pickerEndDate"></mat-datepicker-toggle>
                                <mat-datepicker #pickerEndDate></mat-datepicker>
                                <mat-icon matSuffix class="x-icon" *ngIf="actualFilters.endDate"
                                    (click)="cleanFilter('endDate')">cancel</mat-icon>
                            </mat-form-field>
                        </div>
                        <div class="col-6 xs-12" *ngIf="filtersByOptions.showFilterCreationDateInitial">
                            <mat-form-field>
                                <mat-label>Desde</mat-label>
                                <input matInput [matDatepicker]="pickerCreationDateInitial"
                                    (dateChange)="onChangeCreationDate($event, 'creationDateInitial')"
                                    [formControl]="creationDateInitial">
                                <mat-datepicker-toggle matSuffix
                                    [for]="pickerCreationDateInitial"></mat-datepicker-toggle>
                                <mat-datepicker #pickerCreationDateInitial></mat-datepicker>
                                <mat-icon matSuffix class="x-icon" *ngIf="actualFilters.creationDateInitial"
                                    (click)="cleanFilter('creationDateInitial')">cancel</mat-icon>
                            </mat-form-field>
                        </div>
                        <div class="col-6 xs-12" *ngIf="filtersByOptions.showFilterCreationDateFinal">
                            <mat-form-field>
                                <mat-label>Hasta</mat-label>
                                <input matInput [min]="minCreationDateFinal" [matDatepicker]="pickerCreationDateFinal"
                                    (dateChange)="onChangeCreationDate($event, 'creationDateFinal')"
                                    [formControl]="creationDateFinal"
                                    [readonly]="utils.isEmpty(creationDateInitial.value)"
                                    [disabled]="utils.isEmpty(creationDateInitial.value)">
                                <mat-datepicker-toggle matSuffix
                                    [for]="pickerCreationDateFinal"></mat-datepicker-toggle>
                                <mat-datepicker #pickerCreationDateFinal></mat-datepicker>
                                <mat-icon matSuffix class="x-icon" *ngIf="actualFilters.creationDateFinal"
                                    (click)="cleanFilter('creationDateFinal')">cancel</mat-icon>
                            </mat-form-field>
                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions.showFilterNumberDocumentDriver || scheduledLoadsTab">
                            <app-input-document-user [inputFormControl]="documentDriverControl"
                                [options]="optionsDocumentUser"></app-input-document-user>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterOriginDestination">
                            <app-autocomplete-city [options]="optionsCityOrigin"
                                [inputFormControl]="cityControlOrigin"></app-autocomplete-city>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterOriginDestination">
                            <app-autocomplete-city [options]="optionsCityDestination"
                                [inputFormControl]="cityControlDestination"></app-autocomplete-city>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterPrevalidationValid">
                            <mat-form-field>
                                <mat-label>Estado de la validación</mat-label>
                                <mat-select [formControl]="form.get('prevalidationValid')">
                                    <mat-option value="true">
                                        Validado
                                    </mat-option>
                                    <mat-option value="false">
                                        Pendiente de validación
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterRequiresPreBill">
                            <mat-form-field>
                                <mat-label>Requiere pre-factura</mat-label>
                                <mat-select [formControl]="form.get('requiresPreBill')">
                                    <mat-option value="">Todos</mat-option>
                                    <mat-option value="true">Si</mat-option>
                                    <mat-option value="false">No</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterPreBill">
                            <mat-form-field>
                                <mat-label>Pre-factura</mat-label>
                                <input type="text" matInput formControlName="preBill" onlyNumbersInt>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterMainConsecutive">
                            <mat-form-field>
                                <mat-label>Nº ID consolidado base</mat-label>
                                <input type="text" matInput onlyNumbersInt formControlName="consecutiveMainCargo">
                            </mat-form-field>
                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions?.showFilterVehicleTrailerId && hasTransportServicesCompany">
                            <mat-form-field>
                                <mat-label>Trailer</mat-label>
                                <input type="text" appLicensePlate matInput formControlName="trailerId">
                            </mat-form-field>
                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions.showfilterEscortedLicensePlate && (hasSatelliteLockServicesCompany || hasEscortServicesCompany)">
                            <mat-form-field>
                                <mat-label>Placa escoltada {{hasSatelliteLockServicesCompany ? '(A seguir)' :
                                    ''}}</mat-label>
                                <input appLicensePlate type="text" matInput formControlName="escortedLicensePlate">
                            </mat-form-field>
                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions.showFilterImeiLock && hasSatelliteLockServicesCompany">
                            <mat-form-field>
                                <mat-label>IMEI del candado satelital</mat-label>
                                <input type="text" matInput formControlName="imeiLock">
                            </mat-form-field>
                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions.showFilterLockId && hasSatelliteLockServicesCompany">
                            <mat-form-field>
                                <mat-label>ID del candado satelital</mat-label>
                                <input type="text" matInput formControlName="lockId">
                            </mat-form-field>
                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions.showFilterTypeNameLock && hasSatelliteLockServicesCompany">
                            <app-autocomplete-satellite-lock-type [options]="optionsSatelliteLockType"
                                [inputFormControl]="formControlSatelliteLockType"></app-autocomplete-satellite-lock-type>
                        </div>

                        <mat-form-field appearance="outline"
                            *ngIf="filtersByOptions.showFilterPublicationZone && hasTransportServicesCompany"
                            class="col-12 d-xl-none d-block">
                            <mat-label>Zona</mat-label>
                            <mat-select [formControl]="form.get('zone')" (selectionChange)="search()">
                                <mat-option value="private">
                                    Privada
                                </mat-option>
                                <mat-option value="public">
                                    Pública
                                </mat-option>
                                <mat-option value="reserved">
                                    Reservada
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterByTag">
                            <mat-form-field appearance="standard">
                                <mat-label>Etiqueta</mat-label>
                                <mat-select [(formControl)]="tagControl" (selectionChange)="selectTag($event)">
                                    <mat-option *ngFor="let tag of tags" [value]="tag.name"
                                        [disabled]="form.get('labels')?.value?.includes(tag.name)">
                                        {{tag.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions.showFilterByTag && form.get('labels')?.value?.length">
                            <mat-chip class="chip" *ngFor="let tag of form.get('labels')?.value">
                                {{tag}}
                                <mat-icon matChipRemove (click)="clearTag(tag)">cancel</mat-icon>
                            </mat-chip>
                        </div>

                        <div class="col-12" *ngIf="filtersByOptions.showFilterLastPointExistance">
                            <mat-form-field>
                                <mat-label>Último seguimiento registrado</mat-label>
                                <mat-select formControlName="lastPointExistance"
                                    (selectionChange)="clearLastPointLapse($event)">
                                    <mat-option value="true">
                                        Con seguimientos
                                    </mat-option>
                                    <mat-option value="false">
                                        Sin seguimientos
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions.showFilterLastPointLapse && form.get('lastPointExistance')?.value!=='false'">
                            <mat-form-field>
                                <mat-label>Lapso a último seguimiento</mat-label>
                                <input type="text" matInput onlyNumbersInt formControlName="lastPointLapse">
                                <p matSuffix class="mr-2">hrs</p>
                            </mat-form-field>
                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions.showFilterContainerExpirationLapse && hasTransportServicesCompany">
                            <mat-form-field>
                                <mat-label>Lapso a caducidad del contenedor</mat-label>
                                <input type="text" matInput onlyNumbersInt formControlName="containerExpirationLapse">
                                <p matSuffix class="mr-2">días</p>
                            </mat-form-field>
                        </div>

                        <div class="col-12" *ngIf="filtersByOptions.showFilterContainer && hasTransportServicesCompany">
                            <mat-form-field>
                                <mat-label>Contenedor</mat-label>
                                <input type="text" matInput containerNumber formControlName="container">
                            </mat-form-field>
                        </div>

                        <div class="col-12" *ngIf="filtersByOptions.showFilterCategory">
                            <mat-form-field>
                                <mat-label>Categoría</mat-label>
                                <mat-select formControlName="tripCategory">
                                    <mat-option value="Urbana">
                                        Urbana
                                    </mat-option>
                                    <mat-option value="Nacional">
                                        Nacional
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterNumberDocument">
                            <mat-form-field>
                                <mat-label>Código de identificador cliente</mat-label>
                                <input type="text" matInput formControlName="numberDocumentSender">
                            </mat-form-field>
                        </div>

                        <div class="col-12"
                            *ngIf="filtersByOptions.showfilterManifestCargo && hasTransportServicesCompany">
                            <mat-form-field>
                                <mat-label>Nº Manifiesto</mat-label>
                                <input type="text" matInput formControlName="manifest">
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showfilterIdBill">
                            <mat-form-field>
                                <mat-label>Nº ID factura</mat-label>
                                <input type="text" matInput formControlName="billId">
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="!isTabLoadingRoutes && filtersByOptions.showFilterTripTypeName">
                            <mat-form-field>
                                <mat-label>Tipo de carga</mat-label>
                                <mat-select formControlName="tripTypeName">
                                    <mat-option *ngFor="let type of cargoTypes" [value]="type">
                                        {{type}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions.showFilterRegimeType && hasTransportServicesCompany">
                            <mat-form-field>
                                <mat-label>Tipo de régimen</mat-label>
                                <mat-select formControlName="regimenType">
                                    <mat-option value="OTM">
                                        OTM
                                    </mat-option>
                                    <mat-option value="DTA">
                                        DTA
                                    </mat-option>
                                    <mat-option value="DUTA">
                                        DUTA
                                    </mat-option>
                                    <mat-option value="DTAI">
                                        DTAI
                                    </mat-option>
                                    <mat-option value="Nacionalizado">
                                        Nacionalizado
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterRiskProfile">
                            <mat-form-field>
                                <mat-label>Perfil de riesgo</mat-label>
                                <mat-select formControlName="riskProfileId">
                                    <mat-option *ngFor="let profile of riskProfiles" [value]="profile.id">
                                        {{profile.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterFintech && hasFastPaymentEnabled">
                            <mat-form-field>
                                <mat-label>Pronto Pago</mat-label>
                                <mat-select formControlName="fastPayment">
                                    <mat-option value="true">
                                        Servicios con pronto pago
                                    </mat-option>
                                    <mat-option value="false">
                                        Servicios sin pronto pago
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions.showFilterApprovalState && staticFilters['fastPayment'] === true">
                            <mat-form-field>
                                <mat-label>Aprobación</mat-label>
                                <mat-select formControlName="approval">
                                    <mat-option value="">Todos</mat-option>
                                    <mat-option value="Rejected">Rechazados</mat-option>
                                    <mat-option value="Approved">Aprobados</mat-option>
                                    <mat-option value="Pending approval">Pendientes de aprobación</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterConfirmedDriver">
                            <mat-form-field>
                                <mat-label>Por confirmación {{hasTransportServicesCompany ? 'del conductor' :
                                    ''}}</mat-label>
                                <mat-select formControlName="confirmedDriver">
                                    <mat-option value="true">
                                        Servicios {{hasSatelliteLockServicesCompany ? 'confirmados' : 'de conductor
                                        confirmado'}}
                                    </mat-option>
                                    <mat-option value="false">
                                        Servicios {{hasSatelliteLockServicesCompany ? 'sin confirmar' : 'sin conductor
                                        confirmado'}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterAmount && hasTransportServicesCompany">
                            <mat-form-field>
                                <mat-label>Valor declarado de la mercancia</mat-label>
                                <mat-select [(ngModel)]="filterAmountValue" (selectionChange)="setAmount($event)"
                                    [ngModelOptions]="{standalone: true}">
                                    <mat-option *ngFor="let amount of cargoManager.amountsCargo" [value]="amount">
                                        <div *ngIf="amount?.start <= 0">Hasta {{amount?.end | currency:'COP'}}</div>
                                        <div *ngIf="!isFinite(amount?.end)">Desde {{amount?.start | currency:'COP'}}
                                        </div>
                                        <div *ngIf="amount?.start > 0 && isFinite(amount?.end)">
                                            Entre {{amount?.start | currency:'COP'}} y {{amount?.end |
                                            currency:'COP'}}
                                        </div>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                    </div>
                    <!--User filters-->
                    <div *ngIf="filterBy==='user'" class="w-100 d-flex flex-wrap">
                        <div class="col-12"
                            *ngIf="filtersByOptions.showFilterRole && staticFilters['type']==='userClient'">
                            <mat-form-field>
                                <mat-label>Rol</mat-label>
                                <mat-select formControlName="role">
                                    <mat-option *ngFor="let role of roles" [value]="role.name">
                                        {{role.name | roleTranslate}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterStateUser">
                            <mat-form-field>
                                <mat-label>Estado</mat-label>
                                <mat-select formControlName="state">
                                    <mat-option *ngFor="let state of userStates" [value]="state.value">
                                        {{state.name}}
                                    </mat-option>
                                    <mat-option [value]="'1'" *ngIf="staticFilters['type']==='user'" permission-display
                                        [module]="permission.administration.module"
                                        [functionality]="permission.administration.showDocumentsPendingDrivers">
                                        Con documentos pendientes por validar
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-12" *ngIf="filtersByOptions.showFilterDocument">
                            <mat-form-field>
                                <mat-label>Documento</mat-label>
                                <input type="text" matInput onlyNumbersInt formControlName="document">
                                <mat-error *ngIf="form.get('document').errors?.maxlength">
                                    {{ utils.giveMessageError('MAX_LENGTH_EXCEED', 'documento', 15) }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterPhone">
                            <mat-form-field>
                                <mat-label>Celular</mat-label>
                                <input type="text" matInput formControlName="phone">
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions.showFilterEmail">
                            <mat-form-field>
                                <mat-label>Correo electrónico</mat-label>
                                <input type="text" matInput formControlName="email">
                                <mat-error *ngIf="form.get('email').errors?.pattern">
                                    {{ utils.giveMessageError('INCORRECT_FORMAT', 'correo') }}
                                </mat-error>
                                <mat-error *ngIf="form.get('email').errors?.maxlength">
                                    {{ utils.giveMessageError('MAX_LENGTH_EXCEED', 'correo', 100) }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <!--Vehicles filters-->
                    <div *ngIf="filterBy==='vehicle'" class="w-100 d-flex flex-wrap">
                        <div class="col-12" *ngIf="filtersByOptions?.showFilterVehicleCompany && isRootNit">
                            <app-select-company [options]="optionsCompanyfilter" [inputFormControl]="companySelected">
                            </app-select-company>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions?.showFilterVehicleLicensePlate">
                            <mat-form-field>
                                <mat-label>Placa</mat-label>
                                <input type="text" appLicensePlate matInput formControlName="id">
                            </mat-form-field>
                        </div>
                        <div class="col-12"
                            *ngIf="filtersByOptions?.showFilterVehicleTrailerId && hasTransportServicesCompany">
                            <mat-form-field>
                                <mat-label>Trailer</mat-label>
                                <input type="text" appLicensePlate matInput formControlName="trailerId">
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions?.showFilterVehicleType">
                            <mat-form-field>
                                <mat-label>Tipo</mat-label>
                                <mat-select formControlName="type">
                                    <mat-option *ngFor="let type of vehicleTypes" [value]="type.name">
                                        {{type.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions?.showFilterVehicleAccountState">
                            <mat-form-field>
                                <mat-label>Estado de cuenta</mat-label>
                                <mat-select [(ngModel)]="filterAccountState" (selectionChange)="setAccountState($event)"
                                    [ngModelOptions]="{standalone: true}">
                                    <mat-option *ngFor="let accountState of listStateAccountBank"
                                        [value]="accountState">
                                        {{accountState.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions?.showFilterVehicleState">
                            <mat-form-field>
                                <mat-label>Estado</mat-label>
                                <mat-select formControlName="state">
                                    <mat-option value="true">
                                        Activo
                                    </mat-option>
                                    <mat-option value="false">
                                        Inactivo
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions?.showFilterVehicleDriver">
                            <mat-form-field>
                                <mat-label>Conductor</mat-label>
                                <input type="text" onlyNumbersInt matInput formControlName="driver">
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions?.showFilterVehicleOwner">
                            <mat-form-field>
                                <mat-label>Propietario</mat-label>
                                <input type="text" onlyNumbersInt matInput formControlName="owner">
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions?.showFilterVehicleAdministrator">
                            <mat-form-field>
                                <mat-label>Administrador</mat-label>
                                <input type="text" onlyNumbersInt matInput formControlName="administrator">
                            </mat-form-field>
                        </div>
                    </div>
                    <!--Satellite Lock filters-->
                    <div *ngIf="filterBy==='satelliteLock'" class="w-100 d-flex flex-wrap">
                        <div class="col-12" *ngIf="filtersByOptions?.showFilterSatelliteLockId">
                            <mat-form-field>
                                <mat-label>ID</mat-label>
                                <input type="text" matInput formControlName="id">
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions?.showFilterSatelliteLockType">
                            <app-autocomplete-satellite-lock-type [options]="optionsSatelliteLockType"
                                [inputFormControl]="formControlSatelliteLockType"></app-autocomplete-satellite-lock-type>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions?.showFilterSatelliteLockStateDevice">
                            <mat-form-field>
                                <mat-label>Estado del dispositivo</mat-label>
                                <mat-select formControlName="stateDevice">
                                    <mat-option [value]="SatelliteLockStateDevice.ACTIVE">
                                        Activo
                                    </mat-option>
                                    <mat-option [value]="SatelliteLockStateDevice.INACTIVE">
                                        Inactivo
                                    </mat-option>
                                    <mat-option [value]="SatelliteLockStateDevice.IN_MAINTENANCE">
                                        En mantenimiento
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-12" *ngIf="filtersByOptions?.showFilterSatelliteLockIMEI">
                            <mat-form-field>
                                <mat-label>IMEI</mat-label>
                                <input type="text" matInput formControlName="imei">
                            </mat-form-field>
                        </div>
                    </div>
                </div>

            </div>
            <mat-card-actions class="filter-actions-footer d-flex justify-content-around">
                <button mat-raised-button class="primary-secondary flex-fill" color="primary" title="Cerrar"
                    type="button" (click)="closeLateralFilter()">Cerrar
                </button>
                <button mat-raised-button class="flex-fill" color="primary" title="Filtrar" type="button"
                    (click)="applyFilter()">Filtrar
                </button>
            </mat-card-actions>
        </div>